import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * News art (dashboard and History): three headline cards, each led by a
 * small date pill, then a headline and a lighter summary line. The newest
 * card is outlined in the accent.
 */
const CARDS: [number, number, boolean][] = [
  [12, 62, true],
  [40, 74, false],
  [68, 54, false],
]

export function NewsArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {CARDS.map(([y, summaryWidth, newest]) => (
        <g key={y}>
          <rect
            x={12}
            y={y}
            width={136}
            height={22}
            rx={4}
            fill="hsl(var(--foreground) / 0.06)"
            stroke={newest ? 'hsl(var(--primary) / 0.5)' : 'hsl(var(--muted-foreground) / 0.22)'}
            strokeWidth="1.5"
            vectorEffect="non-scaling-stroke"
          />
          <rect
            x={19}
            y={y + 6}
            width={18}
            height={10}
            rx={3}
            fill={newest ? 'hsl(var(--primary) / 0.45)' : 'hsl(var(--muted-foreground) / 0.3)'}
          />
          <rect
            x={43}
            y={y + 5}
            width={88}
            height={5}
            rx={2}
            fill={newest ? 'hsl(var(--foreground) / 0.28)' : 'hsl(var(--foreground) / 0.22)'}
          />
          <rect
            x={43}
            y={y + 13}
            width={summaryWidth}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.12)"
          />
        </g>
      ))}
    </svg>
  )
}
